export class IJobAdd {
  CompanyId: number | undefined;
  CompanyContactId: number | undefined;
  SysUserId: number | undefined;
  JobTitle: string | undefined;
  JobLocation: string | undefined;
  JobDescriptionFile: File | undefined;
  JobDescription: string | undefined;
  Note: string | undefined;
  CompensationTypeId: number | undefined;
  PositionTypeId: number | undefined;
  CompensationFromId: number | undefined;
  CompensationFrom: number | undefined;
  CompensationToId: number | undefined;
  CompensationTo: number | undefined;
  IsAdmin: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/IJobAdd.model.ts